import { render, staticRenderFns } from "./checklist-input.vue?vue&type=template&id=28ef18af"
import script from "./checklist-input.vue?vue&type=script&lang=js"
export * from "./checklist-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports